import { useCallback } from 'react'
import cn from 'classnames/bind'

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import { Loading } from 'app/common/templates-next/page-template'
import usePopup from 'app/common/hooks/usePopup'

import { AddRemoveDietFoodTypes } from './addRemoveDietFoodTypes'

import styles from './DietFoodTypes.module.scss'
import { DietFoodList } from './dietFoodList/DietFoodList'
import { useSchoolDietFoodTypes, useSchoolDietFoodTypesMutate } from 'app/dataProviders/org/dietFoodTypes/hooks'
import { OrgId } from 'app/dataTypes/org'
import { DietFoodTypeId } from 'app/dataTypes/org/dietFoodTypes'


const cx = cn.bind(styles)

type Props = {
  orgId: OrgId
}

export const DietFoodTypes = ({ orgId }: Props) => {
  const { data, loading, requestRef } = useSchoolDietFoodTypes({ params: { orgId } })
  const { submit, remove, pending } = useSchoolDietFoodTypesMutate({ orgId })



  const popup = usePopup()


  const handleSubmit = useCallback(async (Ids: Array<DietFoodTypeId>) => {
    const res = await submit(Ids)
    if (res) {
      popup('Список диет. питания успешно изменен')
      requestRef.current()
    }
    return !!res
  }, [submit, requestRef, popup])

  const handleDelete = useCallback(async (id: DietFoodTypeId) => {
    const res = await remove(id)
    if (res) {
      popup('Пункт диет. питания успешно удален из списка')
      requestRef.current()
    }
    return !!res
  }, [remove, requestRef, popup])




  return (
    <div className={cx(styles.root)}>
      <div className={styles.addRemoveAndCopy}>
        <div>
          <h3 className={styles.header}>{'Диетическое питание'}</h3>
          <AddRemoveDietFoodTypes
            orgId={orgId}
            dietFoodTypesUsed={data}
            onSubmit={handleSubmit}
          >
            {toggle => (
              <PlainButtonAsLink onClick={toggle} disabled={pending}>
                {'Редактировать список'}
              </PlainButtonAsLink>
            )}
          </AddRemoveDietFoodTypes>
        </div>
      </div>

      {loading
        ? <Loading />
        : <DietFoodList
          dietFoodTypes={data}
          disabled={pending}
          onDelete={handleDelete}
        />
      }
    </div>
  )
}

